import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'


const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]"
}
const _hoisted_4 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "btn-list-users tw-flex tw-justify-end tw-mb-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn tw-flex tw-items-center tw-text-[#FFFFFF] tw-bg-[#00A0DA] tw-rounded-full",
    "data-bs-toggle": "modal",
    "data-bs-target": "#exampleModalUsers"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users tw-text-[#FFFFFF] tw-text-[30px] tw-pr-3" }),
    /*#__PURE__*/_createTextVNode(" SEE ECONOMIC SHEET ")
  ])
], -1)
const _hoisted_6 = {
  class: "modal fade modal-xl",
  id: "exampleModalUsers",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "modal-dialog" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = { class: "modal-header" }
const _hoisted_10 = {
  key: 0,
  class: "comment-box"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "\"Action.\"", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "\"Watch Scenario.\"", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close custom-close-button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
], -1)
const _hoisted_15 = { class: "modal-body" }
const _hoisted_16 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_17 = { class: "tw-flex tw-gap-3" }
const _hoisted_18 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Name", -1)
const _hoisted_20 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PhoneNumber", -1)
const _hoisted_22 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Date", -1)
const _hoisted_24 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATION DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  class: "modal fade modal-xl",
  id: "exampleModal4858",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel4858",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog" }
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_39 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_40 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_41 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_42 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SECTION"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCENARIO"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WATCH SCENARIO")
  ])
], -1)
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  class: "modal fade modal-xl",
  id: "exampleModalEscenarioFlipAsIs",
  tabindex: "-1",
  "aria-labelledby": "exampleModalEscenarioFlipAsIs",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog" }
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_55 = { class: "modal-body" }
const _hoisted_56 = { class: "tw-flex tw-justify-end tw-gap-[40px] tw-pr-7" }
const _hoisted_57 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print tw-text-[#FFFFFF] tw-pr-2" }, null, -1)
const _hoisted_59 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope tw-text-[#FFFFFF] tw-text-[18px] tw-pr-2" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("section", { slot: "pdf-content" }, null, -1)
const _hoisted_62 = {
  class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-",
  id: "printable-target"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h1", { class: "pb-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("FLIP AS IS"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" PROFIT OF ESTIMATED COST/BENEFITS")
  ])
], -1)
const _hoisted_64 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_65 = {
  key: 0,
  class: "tw-flex tw-justify-start gap-3 tw-w-full"
}
const _hoisted_66 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_67 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "CUSTOMER INFORMATION")
  ])
], -1)
const _hoisted_69 = { class: "data" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_71 = { class: "data" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER", -1)
const _hoisted_73 = { class: "data" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL", -1)
const _hoisted_75 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "PROPERTY INFORMATION")
  ])
], -1)
const _hoisted_77 = { class: "data" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("td", null, "COUNTY", -1)
const _hoisted_79 = { class: "data" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY ADDRESSES", -1)
const _hoisted_81 = { class: "data" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", null, "ZIP-CODE", -1)
const _hoisted_83 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "AUCTION")
  ])
], -1)
const _hoisted_85 = { class: "data" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("td", null, "AUCTION DATES", -1)
const _hoisted_87 = { class: "data" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("td", null, "CASE #ID", -1)
const _hoisted_89 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "PROPERTY VALUE")
  ])
], -1)
const _hoisted_91 = { class: "data" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("td", null, "CLERK-FEES", -1)
const _hoisted_93 = { class: "data" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("td", null, "DOC STAMPS ", -1)
const _hoisted_95 = { class: "data" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("td", null, "SEARCH-TITLE-COMPANY", -1)
const _hoisted_97 = { class: "data" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("td", null, "ATTORNEY-HOURS", -1)
const _hoisted_99 = { class: "data" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("td", null, "ATTORNEY-PAYMENT", -1)
const _hoisted_101 = { class: "data" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-ARRAGNGMENT %", -1)
const _hoisted_103 = { class: "data" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-ARRAGNGMENT-AMOUNT", -1)
const _hoisted_105 = { class: "data" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("td", null, "OTHER-EXPENSES-AMOUNT", -1)
const _hoisted_107 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "SELL PROPERTY")
  ])
], -1)
const _hoisted_109 = { class: "data" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("td", null, "SELLER-AGENT-COMMISSION", -1)
const _hoisted_111 = { class: "data" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("td", null, "BUYER-AGENT-COMMISSION", -1)
const _hoisted_113 = { class: "data" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("td", null, "SELLER-CLOSING-COST", -1)
const _hoisted_115 = { class: "data" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("td", null, "BROKER-PAYMENT", -1)
const _hoisted_117 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "TEMPORARY MONTHLY PAYMENTS")
  ])
], -1)
const _hoisted_119 = { class: "data" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("td", null, "# MONTHS", -1)
const _hoisted_121 = { class: "data" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("td", null, "ANNUAL-PROPERTY-TAXES", -1)
const _hoisted_123 = { class: "data" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-TAXES", -1)
const _hoisted_125 = { class: "data" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("td", null, "ANNUAL-PROPERTY-INSURANCE", -1)
const _hoisted_127 = { class: "data" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-INSURANCE", -1)
const _hoisted_129 = { class: "data" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("td", null, "ANNUAL-FEDERAL-TAXES", -1)
const _hoisted_131 = { class: "data" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("td", null, "FEDERAL-TAXES", -1)
const _hoisted_133 = { class: "data" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("td", null, "ASSOCIATION-PAYMENT", -1)
const _hoisted_135 = { class: "table table-bordered border-0 mb-0 table-edit table-no-radius" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "PROFIT REQUIRED")
  ])
], -1)
const _hoisted_137 = { class: "data" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("td", null, "BENEFIT-NET-PROFIT-REQUIRED %", -1)
const _hoisted_139 = { class: "data" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("td", null, "BENEFIT NET PROFIT $", -1)
const _hoisted_141 = { class: "data" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("td", null, "PLACE BID", -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 pb-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-font-medium tw-text-[18px]" }, "Note:"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" The investment outcome presented here is an estimate subject to potential "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" fluctuations arising from the execution of the project. ")
  ])
], -1)
const _hoisted_144 = {
  class: "modal fade",
  id: "exampleModalMessage",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_145 = { class: "modal-dialog" }
const _hoisted_146 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_148 = { class: "modal-body" }
const _hoisted_149 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "USER-EMAIL: ", -1)
const _hoisted_151 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_153 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_155 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_156 = { class: "tw-flex tw-justify-start tw-items-center" }
const _hoisted_157 = {
  key: 0,
  class: "btn-attach tw-bg-[#E6E7E8] tw-h-[40px] tw-font-bold tw-px-4 tw-rounded-full tw-text-xl"
}
const _hoisted_158 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip tw-text-gray-500" }, null, -1)
const _hoisted_159 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_160 = ["disabled"]
const _hoisted_161 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2" }, " INVESTMENT FLIP AS IS", -1)
const _hoisted_163 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-5 tw-mt-3" }
const _hoisted_164 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExampleFlipTittle",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("b", null, "TITLE COMPANY     ▼")
], -1)
const _hoisted_166 = {
  class: "collapse",
  id: "collapseExampleFlipTittle"
}
const _hoisted_167 = { class: "card card-body tw-px-[80px]" }
const _hoisted_168 = {
  class: "tw-px-[30px]",
  style: {"border":"1px solid #b0b0b0"}
}
const _hoisted_169 = { class: "tw-flex tw-justify-around mt-3 mb-3" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_171 = { class: "pb-3" }
const _hoisted_172 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CLOSING CLOSE"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "OTHER PRICE")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "BUYER"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "SELLER"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, [
      /*#__PURE__*/_createTextVNode("SEARCH TITLE "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" COMPANY")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "CHAIN TITTLE")
  ])
], -1)
const _hoisted_174 = {
  key: 0,
  class: "data"
}
const _hoisted_175 = ["onClick"]
const _hoisted_176 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExample88",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("b", null, "INSPECTOR     ▼")
], -1)
const _hoisted_178 = {
  class: "collapse",
  id: "collapseExample88"
}
const _hoisted_179 = { class: "card card-body" }
const _hoisted_180 = { class: "tw-flex tw-justify-around" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_182 = /*#__PURE__*/_createElementVNode("button", { class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]" }, "GET IT", -1)
const _hoisted_183 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-5" }, null, -1)
const _hoisted_184 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " CUSTOMER ", -1)
const _hoisted_186 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_187 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_188 = { class: "tw-w-full" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NAME", -1)
const _hoisted_190 = { class: "tw-w-full" }
const _hoisted_191 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PHONE NUMBER", -1)
const _hoisted_192 = { class: "tw-w-full" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "EMAIL", -1)
const _hoisted_194 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " PROPERTY INFORMATION ", -1)
const _hoisted_196 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_197 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_198 = { class: "tw-w-full" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "STATE", -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Choose...", -1)
const _hoisted_201 = ["value"]
const _hoisted_202 = { class: "tw-w-full" }
const _hoisted_203 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "COUNTY", -1)
const _hoisted_204 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Choose...", -1)
const _hoisted_205 = ["value"]
const _hoisted_206 = { class: "tw-w-full" }
const _hoisted_207 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROPERTY ADDRESSES", -1)
const _hoisted_208 = { class: "tw-w-full" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "ZIP-CODE", -1)
const _hoisted_210 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_211 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " AUCTION ", -1)
const _hoisted_212 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_213 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_214 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_215 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " AUCTION DATES ", -1)
const _hoisted_216 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_217 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_218 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " CASE # ID ", -1)
const _hoisted_219 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_220 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " PROPERTY VALUE ", -1)
const _hoisted_222 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_223 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_224 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ESTIMATE MARKET VALUE ", -1)
const _hoisted_226 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_227 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_228 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FINAL JUDMENT AMOUNT ", -1)
const _hoisted_229 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_230 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_231 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " SELL PRICE ", -1)
const _hoisted_232 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_233 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_234 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " PROPERTY EXPENSES ", -1)
const _hoisted_235 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_236 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_237 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_238 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " CLERK FEES ", -1)
const _hoisted_239 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_240 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_241 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOC STAMPS ", -1)
const _hoisted_242 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_243 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_244 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " SEARCH TITLE COMPANY ", -1)
const _hoisted_245 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_246 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_247 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ATTORNEY HOURS ", -1)
const _hoisted_248 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_249 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_250 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ATTORNEY PAYMENT ", -1)
const _hoisted_251 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_252 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_253 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY ARRANGMENT % ", -1)
const _hoisted_254 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_255 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_256 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY ARRAGMENT AMOUNT ", -1)
const _hoisted_257 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_258 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_259 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " OTHER EXPENSES AMOUNT ", -1)
const _hoisted_260 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_261 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_262 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, "SELL PROPERTY ", -1)
const _hoisted_263 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_264 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_265 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_266 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " SELLER AGENT COMMISSION ", -1)
const _hoisted_267 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_268 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_269 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BUYER AGENT COMMISSION ", -1)
const _hoisted_270 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_271 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_272 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " SELLER CLOSING COST ", -1)
const _hoisted_273 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_274 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_275 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BROKER PAYMENT ", -1)
const _hoisted_276 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_277 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_278 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " TEMPORARY MONTHLY PAYMENTS ", -1)
const _hoisted_279 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_280 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_281 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_282 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " # MONTHS ", -1)
const _hoisted_283 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_284 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_285 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ANNUAL PROPERTY TAXES ", -1)
const _hoisted_286 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_287 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_288 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES ", -1)
const _hoisted_289 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_290 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_291 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ANNUAL PROPERTY INSURANCE ", -1)
const _hoisted_292 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_293 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_294 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE ", -1)
const _hoisted_295 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_296 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_297 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ANNUAL FEDERAL TAXES ", -1)
const _hoisted_298 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_299 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_300 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAXES ", -1)
const _hoisted_301 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_302 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_303 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION PAYMENT ", -1)
const _hoisted_304 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_305 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_306 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION MONTHLY PAYMENT ", -1)
const _hoisted_307 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_308 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_309 = /*#__PURE__*/_createElementVNode("div", { class: "tw-bg-[#00a0da] d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold mb-0" }, " PROFIT REQUIRED "),
  /*#__PURE__*/_createElementVNode("button", {
    id: "openNoteModalProfitRequired",
    class: "btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold btn-sm",
    style: {"border":"none"},
    "data-bs-toggle": "modal",
    "data-bs-target": "#note-Modal-Profit-Required"
  }, " SEE NOTE ")
], -1)
const _hoisted_310 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_311 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_312 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_313 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BENEFIT NET PROFIT REQUIRED % ", -1)
const _hoisted_314 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_315 = /*#__PURE__*/_createStaticVNode("<div class=\"modal\" id=\"note-Modal-Profit-Required\" tabindex=\"-1\" aria-hidden=\"true\" aria-labelledby=\"label-modal-1\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\"><b>Note:</b></h3><br><p class=\"text-center\">In the &quot;Profit Required&quot; option, the investor should input the desired profit they aim to achieve, keeping in mind that a typical flip has a recovery period of approximately three months.<br> The percentage of profit they wish to earn will determine the offer they need to make. </p><br><div class=\"d-flex justify-content-end\"><button id=\"closeNoteModal\" type=\"button\" class=\"btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]\" data-bs-dismiss=\"modal\" aria-label=\"Close\"> CLose </button></div></div></div></div></div>", 1)
const _hoisted_316 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-8" }
const _hoisted_317 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-px-14" }
const _hoisted_318 = { class: "tw-flex tw-justify-end tw-gap-[30px]" }
const _hoisted_319 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_320 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " BENEFIT NET PROFIT $ ", -1)
const _hoisted_321 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_322 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " PLACE BID ", -1)
const _hoisted_323 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }
const _hoisted_324 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_ResidentialView = _resolveComponent("ResidentialView")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.header === null)
      ? (_openBlock(), _createBlock(_component_TopBar, {
          key: 0,
          helpBar: true,
          helpDescription: "Video tutorial",
          helpVideo: "https://www.realtortools.org/media/Video%20Investment%20Flip%20As%20Is%201.mp4"
        }))
      : _createCommentVNode("", true),
    (!_ctx.foreign)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ResidentialView, {
            header: false,
            onRealtorEvent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeRealtor($event)))
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.foreign)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  id: "openNoteModal1",
                  class: "btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold btn-sm",
                  style: {"border":"none"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleComment && _ctx.toggleComment(...args)))
                }, " SEE NOTE "),
                (_ctx.isCommentVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createTextVNode(" You can find the Economic Sheet by: Name, Phone Number, or Date."),
                      _hoisted_11,
                      _createTextVNode("Then, to filter, click on "),
                      _hoisted_12,
                      _createTextVNode(" On the new screen, click on "),
                      _hoisted_13
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_14
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.scenario.users)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _withDirectives(_createElementVNode("input", {
                          name: "",
                          id: "",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.scenario.users.name) = $event)),
                          class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                        }, null, 512), [
                          [_vModelText, _ctx.params.scenario.users.name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _withDirectives(_createElementVNode("input", {
                          name: "",
                          id: "",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.scenario.users.phonenumber) = $event)),
                          class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                        }, null, 512), [
                          [_vModelText, _ctx.params.scenario.users.phonenumber]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_datepicker, {
                          "auto-apply": "",
                          class: "w-100",
                          range: "",
                          modelValue: _ctx.configDatePicker.date,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                            _ctx.changeDate
                          ],
                          placeholder: "Enter date range..."
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getScenarioUsers())),
                      class: "mb-3 tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]"
                    }, "Filter"),
                    _createElementVNode("table", _hoisted_24, [
                      _hoisted_25,
                      (_ctx.scenario.users.results && _ctx.scenario.users.results.length > 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.users.results, (user) => {
                              return (_openBlock(), _createElementBlock("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(user.user_name), 1),
                                _createElementVNode("td", null, _toDisplayString(user.user_email), 1),
                                _createElementVNode("td", null, _toDisplayString(user.user_phonenumber), 1),
                                _createElementVNode("td", null, _toDisplayString(user.create_date), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("a", {
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#exampleModal4858",
                                    href: "#",
                                    onClick: ($event: any) => (_ctx.loadScenarios(user))
                                  }, _hoisted_29, 8, _hoisted_27)
                                ])
                              ]))
                            }), 256))
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_30, _hoisted_32))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    (_ctx.scenario.userScenarios)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("table", _hoisted_42, [
                            _hoisted_43,
                            (_ctx.scenario.userScenarios.results && _ctx.scenario.userScenarios.results.length > 0)
                              ? (_openBlock(), _createElementBlock("tbody", _hoisted_44, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.userScenarios.results, (userscenario) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(userscenario.code), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.date), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.type), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.type_name), 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("a", {
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#exampleModalEscenarioFlipAsIs",
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.loadScenario(userscenario))
                                        }, _hoisted_47, 8, _hoisted_45)
                                      ])
                                    ]))
                                  }), 256))
                                ]))
                              : (_openBlock(), _createElementBlock("tbody", _hoisted_48, _hoisted_50))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printScenario())),
                    class: "block"
                  }, [
                    _hoisted_58,
                    _createTextVNode("PRINT")
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.generateMail()))
                  }, [
                    _hoisted_60,
                    _createTextVNode("SEND")
                  ]),
                  _createVNode(_component_vue3_html2pdf, {
                    "show-layout": false,
                    "float-layout": true,
                    "enable-download": false,
                    "preview-modal": false,
                    "pdf-quality": 2,
                    "pdf-format": "a4",
                    "pdf-content-width": "800px",
                    "manual-pagination": true,
                    onBeforeDownload: _cache[8] || (_cache[8] = ($event: any) => (_ctx.beforeFileGenerated($event))),
                    ref: "html2Pdf"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_61
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  (_ctx.scenario.scenarioData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("table", _hoisted_67, [
                            _hoisted_68,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_69, [
                                _hoisted_70,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_name), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_71, [
                                _hoisted_72,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_phonenumber), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_73, [
                                _hoisted_74,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_email), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_75, [
                            _hoisted_76,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_77, [
                                _hoisted_78,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyCounty), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_79, [
                                _hoisted_80,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAddresses), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_81, [
                                _hoisted_82,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyZipCode), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_83, [
                            _hoisted_84,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_85, [
                                _hoisted_86,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAuctionDates), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_87, [
                                _hoisted_88,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyCaseId), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_89, [
                            _hoisted_90,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_91, [
                                _hoisted_92,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyClerkFees), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_93, [
                                _hoisted_94,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyDocStamps), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_95, [
                                _hoisted_96,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertySearchTitleCompany), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_97, [
                                _hoisted_98,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAttorneyHours), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_99, [
                                _hoisted_100,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAttorney), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_101, [
                                _hoisted_102,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyArrangment), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_103, [
                                _hoisted_104,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyArragmentAmount), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_105, [
                                _hoisted_106,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyOtherExpensesAmount), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_107, [
                            _hoisted_108,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_109, [
                                _hoisted_110,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertySellerAgentCommission?.text), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_111, [
                                _hoisted_112,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyBuyerAgentCommission?.text), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_113, [
                                _hoisted_114,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertySellerClosingCost?.value), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_115, [
                                _hoisted_116,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyBrokerPayment), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_117, [
                            _hoisted_118,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_119, [
                                _hoisted_120,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyMonths), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_121, [
                                _hoisted_122,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAnnualPropertyTaxes), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_123, [
                                _hoisted_124,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyMonthlyPropertyTaxes), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_125, [
                                _hoisted_126,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAnnualPropertyInsurance), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_127, [
                                _hoisted_128,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyMonthlyPropertyInsurance), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_129, [
                                _hoisted_130,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAnnualStateTaxes), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_131, [
                                _hoisted_132,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyMonthlyStateTaxes), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_133, [
                                _hoisted_134,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAssociationPayment), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_135, [
                            _hoisted_136,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_137, [
                                _hoisted_138,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyBenefitNetProfitRequired), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_139, [
                                _hoisted_140,
                                _createElementVNode("td", null, _toDisplayString(_ctx.benefitNetProfit), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_141, [
                                _hoisted_142,
                                _createElementVNode("td", null, _toDisplayString(_ctx.placeBid), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_143
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_144, [
        _createElementVNode("div", _hoisted_145, [
          _createElementVNode("div", _hoisted_146, [
            _hoisted_147,
            _createElementVNode("div", _hoisted_148, [
              _createElementVNode("div", _hoisted_149, [
                _hoisted_150,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.scenarioMail.email) = $event)),
                  class: "tw-w-full tw-h-[32px]",
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_151, [
                _hoisted_152,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.scenarioMail.subject) = $event)),
                  class: "tw-w-full tw-h-[32px]",
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.subject]
                ])
              ]),
              _createElementVNode("div", _hoisted_153, [
                _withDirectives(_createElementVNode("textarea", {
                  name: "",
                  id: "",
                  cols: "53",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.scenarioMail.message) = $event)),
                  rows: "9"
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.message]
                ])
              ])
            ]),
            _hoisted_154,
            _createElementVNode("div", _hoisted_155, [
              _createElementVNode("div", _hoisted_156, [
                (_ctx.scenarioMail.file)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_157, [
                      _hoisted_158,
                      _createTextVNode(" " + _toDisplayString(_ctx.scenarioMail.file.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("button", {
                  "data-bs-dismiss": "modal",
                  class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                  disabled: _ctx.v$.scenarioMail.$invalid,
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.sendScenarioMail && _ctx.sendScenarioMail(...args)))
                }, "SEND MESSAGE", 8, _hoisted_160)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_161, [
        _hoisted_162,
        _createElementVNode("div", _hoisted_163, [
          _createElementVNode("div", _hoisted_164, [
            _hoisted_165,
            _createElementVNode("div", _hoisted_166, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTitleCompanies, (user) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_167, [
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(user.companyname), 1),
                        _createTextVNode(),
                        _hoisted_170
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_171, [
                      _createElementVNode("table", _hoisted_172, [
                        _hoisted_173,
                        _createElementVNode("tbody", null, [
                          (user.tables[0] !== undefined)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_174, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.tables[0].tabledata[0].data, (tabledata) => {
                                  return (_openBlock(), _createElementBlock("td", null, _toDisplayString(tabledata.table_closing_close) + "%", 1))
                                }), 256)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.tables[0].tabledata[1].data, (tabledata) => {
                                  return (_openBlock(), _createElementBlock("td", null, _toDisplayString(tabledata.table_each_tittle_review), 1))
                                }), 256))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("button", {
                        class: "tw-bg-[#00a0da] tw-px-11 tw-mt-4 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                        onClick: ($event: any) => (_ctx.getItTitleCompany(user))
                      }, "GET IT", 8, _hoisted_175)
                    ])
                  ])
                ]))
              }), 256))
            ])
          ]),
          _createElementVNode("div", _hoisted_176, [
            _hoisted_177,
            _createElementVNode("div", _hoisted_178, [
              _createElementVNode("div", _hoisted_179, [
                _createElementVNode("div", _hoisted_180, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInspectors, (user) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("span", null, _toDisplayString(user.username + " " + user.lastname), 1),
                      _createTextVNode(),
                      _hoisted_181,
                      _hoisted_182
                    ]))
                  }), 256))
                ])
              ])
            ])
          ])
        ]),
        _hoisted_183,
        _createElementVNode("div", _hoisted_184, [
          _hoisted_185,
          _createElementVNode("div", _hoisted_186, [
            _createElementVNode("div", _hoisted_187, [
              _createElementVNode("div", _hoisted_188, [
                _hoisted_189,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customer.name) = $event)),
                  placeholder: "Complete name",
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_190, [
                _hoisted_191,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.customer.phone) = $event)),
                  placeholder: "9999999999",
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_192, [
                _hoisted_193,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.customer.email) = $event)),
                  placeholder: "example@gmail.com",
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.email]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_194, [
          _hoisted_195,
          _createElementVNode("div", _hoisted_196, [
            _createElementVNode("div", _hoisted_197, [
              _createElementVNode("div", _hoisted_198, [
                _hoisted_199,
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.financialInformation.propertyState) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.getCounties()))
                }, [
                  _hoisted_200,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStates, (state) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: state.name
                    }, _toDisplayString(state.name), 9, _hoisted_201))
                  }), 256))
                ], 544), [
                  [_vModelSelect, _ctx.financialInformation.propertyState]
                ])
              ]),
              _createElementVNode("div", _hoisted_202, [
                _hoisted_203,
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.financialInformation.propertyCounty) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2"
                }, [
                  _hoisted_204,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCounties, (country) => {
                    return (_openBlock(), _createElementBlock("option", { value: country }, _toDisplayString(country), 9, _hoisted_205))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.financialInformation.propertyCounty]
                ])
              ]),
              _createElementVNode("div", _hoisted_206, [
                _hoisted_207,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.financialInformation.propertyAddresses) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.financialInformation.propertyAddresses]
                ])
              ]),
              _createElementVNode("div", _hoisted_208, [
                _hoisted_209,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.financialInformation.propertyZipCode) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.financialInformation.propertyZipCode]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_210, [
          _hoisted_211,
          _createElementVNode("div", _hoisted_212, [
            _createElementVNode("table", _hoisted_213, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_214, [
                  _hoisted_215,
                  _createElementVNode("td", _hoisted_216, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.financialInformation.propertyAuctionDates) = $event)),
                      placeholder: "00/00/0000"
                    }, null, 512), [
                      [_vModelText, _ctx.financialInformation.propertyAuctionDates]
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_217, [
                  _hoisted_218,
                  _createElementVNode("td", _hoisted_219, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.financialInformation.propertyCaseId) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.financialInformation.propertyCaseId]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_220, [
          _hoisted_221,
          _createElementVNode("div", _hoisted_222, [
            _createElementVNode("table", _hoisted_223, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_224, [
                  _hoisted_225,
                  _createElementVNode("td", _hoisted_226, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyEstimateMarketValue",
                      value: _ctx.financialInformation.propertyEstimateMarketValue,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.financialInformation.propertyEstimateMarketValue) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_227, [
                  _hoisted_228,
                  _createElementVNode("td", _hoisted_229, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyFinalJudmentAmount",
                      value: _ctx.financialInformation.propertyFinalJudmentAmount,
                      "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.financialInformation.propertyFinalJudmentAmount) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_230, [
                  _hoisted_231,
                  _createElementVNode("td", _hoisted_232, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertySellPrice",
                      value: _ctx.financialInformation.propertySellPrice,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.financialInformation.propertySellPrice) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_233, [
          _hoisted_234,
          _createElementVNode("div", _hoisted_235, [
            _createElementVNode("table", _hoisted_236, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_237, [
                  _hoisted_238,
                  _createElementVNode("td", _hoisted_239, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyPriceTotalCash",
                      value: _ctx.financialInformation.propertyClerkFees,
                      "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.financialInformation.propertyClerkFees) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_240, [
                  _hoisted_241,
                  _createElementVNode("td", _hoisted_242, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyPriceTotalCash",
                      value: _ctx.financialInformation.propertyDocStamps,
                      "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.financialInformation.propertyDocStamps) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_243, [
                  _hoisted_244,
                  _createElementVNode("td", _hoisted_245, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyPriceTotalCash",
                      value: _ctx.financialInformation.propertySearchTitleCompany,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.financialInformation.propertySearchTitleCompany) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_246, [
                  _hoisted_247,
                  _createElementVNode("td", _hoisted_248, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.financialInformation.propertyAttorneyHours) = $event)),
                      onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.calculateProperty('attorney')))
                    }, null, 544), [
                      [_vModelText, _ctx.financialInformation.propertyAttorneyHours]
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_249, [
                  _hoisted_250,
                  _createElementVNode("td", _hoisted_251, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyPriceTotalCash",
                      value: _ctx.financialInformation.propertyAttorney,
                      "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.financialInformation.propertyAttorney) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_252, [
                  _hoisted_253,
                  _createElementVNode("td", _hoisted_254, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.financialInformation.propertyArrangment) = $event)),
                      onInput: _cache[33] || (_cache[33] = ($event: any) => (_ctx.calculateProperty('arragment')))
                    }, null, 544), [
                      [_vModelText, _ctx.financialInformation.propertyArrangment]
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_255, [
                  _hoisted_256,
                  _createElementVNode("td", _hoisted_257, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyPriceTotalCash",
                      value: _ctx.financialInformation.propertyArragmentAmount,
                      "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.financialInformation.propertyArragmentAmount) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_258, [
                  _hoisted_259,
                  _createElementVNode("td", _hoisted_260, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyOtherExpensesAmount",
                      value: _ctx.financialInformation.propertyOtherExpensesAmount,
                      "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.financialInformation.propertyOtherExpensesAmount) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_261, [
          _hoisted_262,
          _createElementVNode("div", _hoisted_263, [
            _createElementVNode("table", _hoisted_264, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_265, [
                  _hoisted_266,
                  _createElementVNode("td", _hoisted_267, _toDisplayString(_ctx.financialInformation.propertySellerAgentCommission?.text !== undefined
                                        ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertySellerAgentCommission?.text)
                                        : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_268, [
                  _hoisted_269,
                  _createElementVNode("td", _hoisted_270, _toDisplayString(_ctx.financialInformation.propertyBuyerAgentCommission?.text !== undefined
                                        ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertyBuyerAgentCommission?.text)
                                        : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_271, [
                  _hoisted_272,
                  _createElementVNode("td", _hoisted_273, _toDisplayString(_ctx.financialInformation.propertySellerClosingCost?.value !== undefined
                                        ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertySellerClosingCost?.value)
                                        : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_274, [
                  _hoisted_275,
                  _createElementVNode("td", _hoisted_276, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyOtherExpensesAmount",
                      value: _ctx.financialInformation.propertyBrokerPayment,
                      "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.financialInformation.propertyBrokerPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_277, [
          _hoisted_278,
          _createElementVNode("div", _hoisted_279, [
            _createElementVNode("table", _hoisted_280, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_281, [
                  _hoisted_282,
                  _createElementVNode("td", _hoisted_283, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.financialInformation.propertyMonths) = $event)),
                      onInput: _cache[38] || (_cache[38] = ($event: any) => (_ctx.calculateProperty('monthlytaxes')))
                    }, null, 544), [
                      [_vModelText, _ctx.financialInformation.propertyMonths]
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_284, [
                  _hoisted_285,
                  _createElementVNode("td", _hoisted_286, [
                    _createElementVNode("div", {
                      onInput: _cache[40] || (_cache[40] = ($event: any) => (_ctx.calculateProperty('monthlytaxes')))
                    }, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyAnnualPropertyTaxes",
                        value: _ctx.financialInformation.propertyAnnualPropertyTaxes,
                        "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.financialInformation.propertyAnnualPropertyTaxes) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ], 32)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_287, [
                  _hoisted_288,
                  _createElementVNode("td", _hoisted_289, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyOtherExpensesAmount",
                      value: _ctx.financialInformation.propertyMonthlyPropertyTaxes,
                      "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.financialInformation.propertyMonthlyPropertyTaxes) = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_290, [
                  _hoisted_291,
                  _createElementVNode("td", _hoisted_292, [
                    _createElementVNode("div", {
                      onInput: _cache[43] || (_cache[43] = ($event: any) => (_ctx.calculateProperty('estimated')))
                    }, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyAnnualPropertyInsurance",
                        value: _ctx.financialInformation.propertyAnnualPropertyInsurance,
                        "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.financialInformation.propertyAnnualPropertyInsurance) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ], 32)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_293, [
                  _hoisted_294,
                  _createElementVNode("td", _hoisted_295, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyOtherExpensesAmount",
                      value: _ctx.financialInformation.propertyMonthlyPropertyInsurance,
                      "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.financialInformation.propertyMonthlyPropertyInsurance) = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_296, [
                  _hoisted_297,
                  _createElementVNode("td", _hoisted_298, [
                    _createElementVNode("div", {
                      onInput: _cache[47] || (_cache[47] = ($event: any) => (_ctx.calculateProperty('monthlystatetaxes')))
                    }, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyAnnualStateTaxes",
                        value: _ctx.financialInformation.propertyAnnualStateTaxes,
                        "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.financialInformation.propertyAnnualStateTaxes) = $event)),
                        onInput: _cache[46] || (_cache[46] = ($event: any) => (_ctx.calculateProperty('monthlystatetaxes'))),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ], 32)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_299, [
                  _hoisted_300,
                  _createElementVNode("td", _hoisted_301, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyOtherExpensesAmount",
                      value: _ctx.financialInformation.propertyMonthlyStateTaxes,
                      "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.financialInformation.propertyMonthlyStateTaxes) = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_302, [
                  _hoisted_303,
                  _createElementVNode("td", _hoisted_304, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyAssociationPayment",
                      value: _ctx.financialInformation.propertyAssociationPayment,
                      "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.financialInformation.propertyAssociationPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_305, [
                  _hoisted_306,
                  _createElementVNode("td", _hoisted_307, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyAssociationPaymentMonthly",
                      value: _ctx.associationMonthlyPayment,
                      "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.associationMonthlyPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_308, [
          _hoisted_309,
          _createElementVNode("div", _hoisted_310, [
            _createElementVNode("table", _hoisted_311, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_312, [
                  _hoisted_313,
                  _createElementVNode("td", _hoisted_314, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "netProfitPercent",
                      value: _ctx.financialInformation.propertyBenefitNetProfitRequired,
                      "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.financialInformation.propertyBenefitNetProfitRequired) = $event)),
                      class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[25px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                      options: { precision: 0, suffix: '% ', prefix: '', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_315,
        _createElementVNode("div", _hoisted_316, [
          _createElementVNode("div", _hoisted_317, [
            _createElementVNode("div", _hoisted_318, [
              _createElementVNode("div", _hoisted_319, [
                _hoisted_320,
                _createVNode(_component_VueNumberFormat, {
                  id: "association",
                  value: _ctx.benefitNetProfit,
                  "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.benefitNetProfit) = $event)),
                  options: {
                                    precision: 0,
                                    prefix: '$ ',
                                    thousand: ',',
                                    acceptNegative: false,
                                    isInteger: false,
                                    decimal: '.',
                                },
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                }, null, 8, ["value", "options"])
              ]),
              _createElementVNode("div", _hoisted_321, [
                _hoisted_322,
                _createVNode(_component_VueNumberFormat, {
                  id: "association",
                  value: _ctx.placeBid,
                  "onUpdate:value": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.placeBid) = $event)),
                  options: {
                                    precision: 0,
                                    prefix: '$ ',
                                    thousand: ',',
                                    acceptNegative: false,
                                    isInteger: false,
                                    decimal: '.',
                                },
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_323, [
          _createElementVNode("button", {
            onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.submitScenario($event))),
            disabled: !_ctx.scenarioValid,
            class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
          }, "SAVE & REGISTER", 8, _hoisted_324)
        ])
      ])
    ])
  ]))
}